import { Injectable } from '@angular/core';
import { MasterdataResponse } from '@entities/masterdata';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MasterdataService {
  constructor(private api: ApiService) {}

  /**
   * マスターデータを取得する
   * @param dataTypeList 取得するデータ種類
   * @param skipLoading ローディング表示をスキップするか
   * @returns データ種類ごとの取得結果
   */
  find(
    dataTypeList: string[],
    skipLoading = false,
  ): Observable<MasterdataResponse> {
    const url = '/masterdata';
    const params = { data: dataTypeList.join(',') };
    return this.api.get<MasterdataResponse>(url, { params }, skipLoading);
  }
}
